import pageComponent from './index.vue'

const page = {
    install : (Vue) => {
        Vue.component('page', pageComponent);
    }
}

export default page



// WEBPACK FOOTER //
// ./src/base/page/index.js